var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('GraphicsEdad',{attrs:{"labels":this.labels,"data":this.data,"highestValue":_vm.highestValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }